import React from 'react';
import { connect } from 'react-redux';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import CheckIcon from '@mui/icons-material/CheckRounded';
import { savePreviewAudioAnalysisDisabled } from '../../../../../utilities/storageUtilities';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const AudioAnalysisOptionSelect = (props) => {
    const { classes, previewAudioAnalysisDisabled, setProperty } = props;

    const onEnabledClick = ()  => {
        setProperty('previewAudioAnalysisDisabled', false);
        savePreviewAudioAnalysisDisabled(false);
    };

    const onDisabledClick = ()  => {
        setProperty('previewAudioAnalysisDisabled', true);
        savePreviewAudioAnalysisDisabled(true);
    };

    return (
        <>
            <MenuItem 
                onClick={onEnabledClick}
                selected={!previewAudioAnalysisDisabled}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: !previewAudioAnalysisDisabled ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    ENABLED
                </ListItemText>
            </MenuItem>
            <MenuItem 
                onClick={onDisabledClick}
                selected={previewAudioAnalysisDisabled}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: previewAudioAnalysisDisabled ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    DISABLED
                </ListItemText>
            </MenuItem>
        </>
    );
};

const mapStateToProps = (state) => {
    const { previewAudioAnalysisDisabled } = state.create;
    return { previewAudioAnalysisDisabled };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AudioAnalysisOptionSelect, styles));